<template>
    <div>
        <span style="    font-weight: bold;">{{curItem.clientName}}</span>
                <el-table 
                :data="doLog" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
                        style="width: 80%;margin-top: 20px;" ref="filterTable" >
                <el-table-column prop="订单编号" sortable align="center" label="订单编号"
                    column-key="订单编号"
                    :filters="orderCodeList"
                    :filter-method="filterHandler"></el-table-column>                
                <el-table-column prop="dealContent" align="center" label="跟进内容" ></el-table-column> 
                <el-table-column prop="dealResult" align="center"  label="跟进结果" ></el-table-column>
                <el-table-column prop="dealDate" sortable align="center" label="跟进时间" ></el-table-column> 
                <!-- <el-table-column align="center" label="附件" >
                    <template slot-scope="scope" >
                        <my-upload-file-form-item v-model="scope.row.sampleArr" label="附件" :limit="10" />
                    </template>
                </el-table-column> -->
                <el-table-column prop="产品名称" align="center"  label="产品名称" ></el-table-column> 
                <el-table-column prop="合约开始周期" align="center"  label="合约开始周期" ></el-table-column>     
                <el-table-column prop="合约结束周期" align="center"  label="合约结束周期" ></el-table-column>  
                <el-table-column prop="订单状态" align="center"  label="订单状态" ></el-table-column>  
                       
            </el-table>

            <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                <el-button @click="closeLogList">关闭</el-button>
            </div> 
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getSampleArrayFromSever} from "@/utils/tools";

export default {
    name: 'baseform',
    props: ['curItem'],
    components: {
        MyUploadFileFormItem
      },
    computed: {
        ...mapGetters(['resultList'])
    },
    data() {
        return {
            doLog:[],            
            orderCodeList:[],
        };
    },

    async mounted() {
        this.init();
    },


    methods: {
        async init(){
            this.doLog=[];
            this.orderCodeList=[];
      
            // [{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]
            await this.$store.dispatch('zc/resultList',{companyId:this.curItem.id,isAgent:this.curItem.isAgent}).then(()=>{
                this.resultList.forEach(ele=>{
                    var obj={};
                    var samples = ele.samples;
                    obj=ele;
                    obj.sampleArr=getSampleArrayFromSever({samples});
                    this.doLog.push(obj);
                });
                const map = new Map()
                var list = this.resultList.filter(key => !map.has(key.订单编号) && map.set(key.订单编号, 1)) // 这里对 订单编号 属性进行去重
                // console.log('this.orderCodeList',this.orderCodeList)
                list.forEach(ele => {
                    this.orderCodeList.push({text:ele.订单编号,value:ele.订单编号});
                });
                // this.logDialogVisible=true;
                
            });     

        },
        
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },

        closeLogList(){
            this.$refs.filterTable.clearFilter();
            // this.logDialogVisible = false;
            this.$emit("onDialogClose");
        },
    }
};
</script>

<style scoped>
</style>